import { AxiosRequestConfig } from 'axios'
import {
  DashboardAsyncTask,
} from '@/typings/api/Dashboard'
import {
  BaseApiResponse as BR,
  BaseApiResponseCollection as BRC,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class AsyncTaskDashboardsApi extends BaseApiAuth<DashboardAsyncTask> {
  protected readonly endpoint = 'core/async_tasks';

  public getAsyncTasks(params?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/'
    const [url] = this.getUrl(path)
    return this.request<unknown, BRC<DashboardAsyncTask>>('GET', url, { params, ...config })
  }

  public runAsyncTask(data: unknown, config: AxiosRequestConfig = {}) {
    const path = 'run/'
    const [url] = this.getUrl(path)
    return this.request<never, BR<never>>('POST', url, { data, ...config })
  }
}
